import { render } from "./delete-topic-modal.vue?vue&type=template&id=0a2eb6ed"
import script from "./delete-topic-modal.vue?vue&type=script&lang=js"
export * from "./delete-topic-modal.vue?vue&type=script&lang=js"
script.render = render

export default script